import React, {Component} from "react";
import PropTypes from "prop-types";
import TextField from "material-ui/TextField";
import {FieldTitle} from "admin-on-rest";
import {AsYouType} from "libphonenumber-js";

export class PhoneNumberInput extends Component {
  handleBlur = eventOrValue => {
    this.props.onBlur(eventOrValue);
    this.props.input.onBlur(eventOrValue);
  };

  handleFocus = event => {
    this.props.onFocus(event);
    this.props.input.onFocus(event);
  };

  handleChange = eventOrValue => {
    this.props.onChange(eventOrValue);
    this.props.input.onChange(eventOrValue);
  };

  render() {
    const {
      elStyle,
      input,
      isRequired,
      label,
      meta,
      options,
      resource,
      source,
      type,
      dialCountry,
      inputStyle,
      floatingLabelStyle,
      underlineStyle,
      underlineFocusStyle,
      underlineShow,
      hintStyle,
      disabled
    } = this.props;
    if (typeof meta === "undefined") {
      throw new Error(
        "The PhoneNumberInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const {touched, error} = meta;

    if (input.value && meta.visited === true) {
      try {
        const asYouType = new AsYouType(dialCountry);
        asYouType.input(input.value);
        input.value = asYouType.getNumber().number;
      } catch (error) {
        console.log("error", error);
      }
    }

    return (
      <TextField
        {...input}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        onChange={this.handleChange}
        type={type}
        disabled={disabled}
        floatingLabelText={
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        }
        errorText={touched && error}
        style={elStyle}
        inputStyle={inputStyle}
        floatingLabelStyle={floatingLabelStyle}
        underlineStyle={underlineStyle}
        underlineFocusStyle={underlineFocusStyle}
        underlineShow={underlineShow}
        hintStyle={hintStyle}
        {...options}
      />
    );
  }
}

PhoneNumberInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  type: PropTypes.string
};

PhoneNumberInput.defaultProps = {
  addField: true,
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  options: {},
  type: "text"
};

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./src/components/CRM/PhoneNumberInput.js